import React from 'react';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import {
  newAccountModalAtom,
  modifyAccountModalAtom,
  deleteModalAtom,
} from '../../models/atoms/account_atoms';
import { AccountListComponent } from '../components/account/AccountList';
import { Stack } from '@mui/material';
import { AccountSearch } from '../components/account/AccountSearch';
import { NewAccountModal } from '../components/account/NewAccountModal';
import { ModifyAccountModal } from '../components/account/ModifyAccountModal';
import { DeleteAccountModal } from '../components/account/DeleteAccountModal';
import { useIsMobile } from '../../hooks/useIsMobile';

export const AccountsPage = memo(function AccountsPage(
  _: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  const newAccountModal = useRecoilValue(newAccountModalAtom);
  const deleteAccountModal = useRecoilValue(deleteModalAtom);
  const modifyAccountModal = useRecoilValue(modifyAccountModalAtom);
  const isMobile = useIsMobile();

  return (
    <>
      {newAccountModal && <NewAccountModal />}
      {modifyAccountModal && <ModifyAccountModal />}
      {deleteAccountModal && <DeleteAccountModal />}
      <Stack p={isMobile ? 0 : 2} gap={2} height="100%">
        <AccountSearch />
        <AccountListComponent />
      </Stack>
    </>
  );
});
